module.exports = __webpack_public_path__ + "img/big-icon-unsupported.a22b79a0.svg";